
        <div class="notyf-wrapper">
            <div class="notyf-icon">
                <i class="notyf-confirm-icon"></i>
            </div>
            <div class="notyf-message">{{ message }}</div>
        </div>
    